import { useRef } from 'react';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';
import { RenewalsSelector } from 'components/RenewalsSelector/RenewalsSelector';

export const RenewalBulkConfigurationModal = ({
  visible,
  renewalConfigs,
  companyChecks,
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const renewalsSelectorRef = useRef(null);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title="Add Renewal Check"
      description="The checks selected here will be added for re-screening to the selected employees if not present already. In case renewal is not configured, but a check of same type exist, next renewal date will be based on it."
      small>
      <RenewalsSelector
        ref={renewalsSelectorRef}
        renewalConfigs={renewalConfigs}
        companyChecks={companyChecks}
        onSubmit={onSubmit}
      />
      <div className="d-flex justify-content-end">
        <Button onClick={() => renewalsSelectorRef.current.submit()}>Add checks to renew</Button>
      </div>
    </AnimatedModal>
  );
};
